// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Utils = require("../../../utils/Utils.bs.js");
var React = require("react");
var Scalars = require("../../../scalars/Scalars.bs.js");
var TanDate = require("../../../reason/common/types/TanDate.bs.js");
var UTCDate = require("../../../reason/common/types/UTCDate.bs.js");
var DateFns = require("date-fns");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var UserSession = require("../../../reason/common/UserSession/UserSession.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var ConversationsListItemContext = require("./ConversationsListItemContext.bs.js");
var ConversationsListItemParticipants = require("./ConversationsListItemParticipants.bs.js");
var ConversationsListItem_lastMessage_graphql = require("../../../__generated__/ConversationsListItem_lastMessage_graphql.bs.js");
var ConversationsListItem_conversation_graphql = require("../../../__generated__/ConversationsListItem_conversation_graphql.bs.js");
var ConversationPageExistingConversationQuery_graphql = require("../../../__generated__/ConversationPageExistingConversationQuery_graphql.bs.js");

var convertFragment = ConversationsListItem_lastMessage_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationsListItem_lastMessage_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationsListItem_lastMessage_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationsListItem_lastMessage_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationsListItem_lastMessage_graphql.node, convertFragment, fRef);
}

var LastMessageFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertFragment$1 = ConversationsListItem_conversation_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationsListItem_conversation_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationsListItem_conversation_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationsListItem_conversation_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(ConversationsListItem_conversation_graphql.node, convertFragment$1, fRef);
}

var ConversationFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function formatRelativeToNow(date) {
  var days = DateFns.differenceInCalendarDays(date, TanDate.now());
  return (
            days !== 0 ? (
                days !== 1 ? (
                    days < 365 ? DateFns.format(date, "eee M/d") : DateFns.format(date, "M/d/yyyy")
                  ) : "Yesterday"
              ) : DateFns.format(date, "h:mm aa")
          ).replace(" ", Utils.$$String.nbsp);
}

function ConversationsListItem(props) {
  var conversation = use$1(props.conversation);
  var lastMessage = use(conversation.lastMessage.fragmentRefs);
  var agent = UserSession.useAgentInfo();
  var hoverRef = React.useRef(undefined);
  React.useEffect((function () {
          return (function () {
                    var timeoutId = hoverRef.current;
                    if (timeoutId !== undefined) {
                      clearTimeout(Caml_option.valFromOption(timeoutId));
                      return ;
                    }
                    
                  });
        }), [hoverRef]);
  var environment = RescriptRelay.useEnvironmentFromContext();
  var participants = Core__Array.keepSome(Core__Option.getOr(Core__Option.map(conversation.participantNames, (function (p) {
                      return p.edges;
                    })), [])).map(function (v) {
          return v.node;
        }).filter(function (v) {
        switch (v.__typename) {
          case "Agent" :
              return v.id !== agent.id;
          case "AnonymousConversationParticipant" :
          case "__unselected" :
              return true;
          
        }
      });
  var match = conversation.unreadMessages;
  var unreadMessages = match !== undefined ? match.totalCount : 0;
  var match$1 = lastMessage.from;
  var senderIsUser = match$1 !== undefined && match$1.__typename === "Agent" ? match$1.id === agent.id : false;
  var participantNames = Core__Array.filterMap(participants, (function (p) {
            switch (p.__typename) {
              case "Agent" :
                  return p.displayName;
              case "AnonymousConversationParticipant" :
                  return "A TAN agent";
              case "__unselected" :
                  return ;
              
            }
          })).join(", ");
  var tmp;
  if (senderIsUser) {
    var match$2 = lastMessage.files;
    var exit = 0;
    if (match$2 !== undefined) {
      var totalCount = match$2.totalCount;
      if (totalCount > 0) {
        tmp = "Sent " + totalCount.toString() + " files";
      } else {
        exit = 1;
      }
    } else {
      exit = 1;
    }
    if (exit === 1) {
      var match$3 = lastMessage.images;
      var exit$1 = 0;
      if (match$3 !== undefined) {
        var totalCount$1 = match$3.totalCount;
        if (totalCount$1 > 0) {
          tmp = "Sent " + totalCount$1.toString() + " images";
        } else {
          exit$1 = 2;
        }
      } else {
        exit$1 = 2;
      }
      if (exit$1 === 2) {
        tmp = "You: " + Core__Option.getOr(lastMessage.text, "");
      }
      
    }
    
  } else {
    var match$4 = lastMessage.files;
    var exit$2 = 0;
    if (match$4 !== undefined) {
      var totalCount$2 = match$4.totalCount;
      if (totalCount$2 > 0) {
        tmp = "Received " + totalCount$2.toString() + " files";
      } else {
        exit$2 = 1;
      }
    } else {
      exit$2 = 1;
    }
    if (exit$2 === 1) {
      var match$5 = lastMessage.images;
      if (match$5 !== undefined) {
        var totalCount$3 = match$5.totalCount;
        tmp = totalCount$3 > 0 ? "Received " + totalCount$3.toString() + " images" : Core__Option.getOr(lastMessage.text, "");
      } else {
        tmp = Core__Option.getOr(lastMessage.text, "");
      }
    }
    
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(ConversationsListItemParticipants.make, {
                            conversation: conversation.fragmentRefs,
                            showNames: false
                          }),
                      className: "p-2"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: participantNames,
                              className: "font-semibold line-clamp-1",
                              title: participantNames
                            }),
                        JsxRuntime.jsx("div", {
                              children: tmp,
                              className: "line-clamp-1"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(ConversationsListItemContext.make, {
                                    conversation: conversation.fragmentRefs
                                  }),
                              className: "my-2"
                            })
                      ],
                      className: "py-2 flex-1"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: unreadMessages !== 0 ? JsxRuntime.jsx("div", {
                                      children: unreadMessages,
                                      className: "rounded-full bg-tan-gold text-white w-5 h-5 flex flex-col items-center justify-center text-sm font-semibold"
                                    }) : null,
                              className: "self-end"
                            }),
                        JsxRuntime.jsx("div", {
                              children: formatRelativeToNow(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(lastMessage.sentAt))),
                              className: "text-sm"
                            })
                      ],
                      className: "py-2 pr-2 flex flex-col space-y-0.5"
                    })
              ],
              className: "flex flex-row",
              onMouseEnter: (function (param) {
                  var timeoutId = hoverRef.current;
                  if (timeoutId !== undefined) {
                    clearTimeout(Caml_option.valFromOption(timeoutId));
                  }
                  hoverRef.current = Caml_option.some(setTimeout((function () {
                              ConversationPageExistingConversationQuery_graphql.load(environment, {
                                    id: conversation.id
                                  }, undefined, undefined, undefined);
                            }), 200));
                }),
              onMouseLeave: (function (param) {
                  var timeoutId = hoverRef.current;
                  if (timeoutId !== undefined) {
                    clearTimeout(Caml_option.valFromOption(timeoutId));
                    return ;
                  }
                  
                })
            });
}

var make = ConversationsListItem;

exports.LastMessageFragment = LastMessageFragment;
exports.ConversationFragment = ConversationFragment;
exports.formatRelativeToNow = formatRelativeToNow;
exports.make = make;
/* Utils Not a pure module */
